import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'history',
    standalone: false
})
export class HistoryPipe implements PipeTransform {
  transform(value) {
    return value.slice(0, -1).reverse();
  }
}
